export default __webpack_public_path__ + "static/media/fad-arrows-horz.ee113cb3.svg";